/**
 * What we leave out — animate the strike-through line on each item once,
 * the first time the section scrolls into view. The CSS handles the
 * actual transition + stagger (via --stagger); this just toggles
 * `is-visible` on the section.
 */
(() => {
  const sections = document.querySelectorAll('.leave-out');
  if (!sections.length) return;

  // Ancient browsers — show final state immediately
  if (!('IntersectionObserver' in window)) {
    sections.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.35, rootMargin: '0px 0px -10% 0px' }
  );

  sections.forEach((el) => observer.observe(el));
})();
